import React from "react";
import CardLoading from "./CardLoading";

interface MetricCardProps {
  title: string;
  count: number | undefined;
  flagsRemoved?: number;
  logoSrc?: string;
  isLoading: boolean;
  /** "NUMBERS" for Clean card, "FLAGGED" for carrier/app/FTC cards */
  label?: string;
  /** Show invisible placeholder text to maintain card height (Apps, FTC) */
  showHeightPlaceholder?: boolean;
  /** Whether remediation flag-removal stats should be shown (Clean, ATT, Verizon, TMobile) */
  showFlagsRemoved?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  count,
  flagsRemoved,
  logoSrc,
  isLoading,
  label = "FLAGGED",
  showHeightPlaceholder = false,
  showFlagsRemoved = false,
}) => {
  return (
    <div className="col-xl-2 col-md-3 col-sm-4 col-6 mt-3 d-flex">
      <div className="card w-100">
        {/* Header */}
        <div
          className="card-header d-flex align-items-center justify-content-center"
          style={{
            height: 48,
            textAlign: "center",
            backgroundColor: "var(--navbar-and-treeview-bg)",
            color: "var(--navbar-link-color-fg)",
            borderColor: "var(--navbar-and-treeview-bg)",
          }}
        >
          {logoSrc ? (
            <img
              src={logoSrc}
              alt={title}
              style={{ height: 30, maxWidth: "100%", width: "auto" }}
            />
          ) : (
            <span style={{ fontSize: 16 }}>{title}</span>
          )}
        </div>

        {/* Card body — flex-grow so all cards fill same height */}
        <div className="card-body d-flex flex-column align-items-center justify-content-center" style={{ padding: "0.75rem" }}>
          {isLoading ? (
            <CardLoading />
          ) : (
            <>
              <span style={{ fontWeight: "bold", fontSize: 14 }}>
                {label}
              </span>
              <span
                style={{
                  fontSize: 20,
                  fontWeight: 700,
                  color: "var(--primary-btn-color)",
                }}
              >
                {(count ?? 0).toLocaleString()}
              </span>
              <div className="mt-1" style={{ fontSize: "0.8rem", minHeight: "2.4em", textAlign: "center" }}>
                {showFlagsRemoved && flagsRemoved !== undefined ? (
                  <><b>{flagsRemoved}</b> flags removed in last 7 days</>
                ) : showHeightPlaceholder ? (
                  <span style={{ visibility: "hidden" }}>placeholder</span>
                ) : null}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
